<template>
  <div class="electricity-tariff pa-10">



    <title-page icon="ico-carplug" class="mb-0">
      {{ $t("electricity-tariff.add") }}
    </title-page>

    <v-breadcrumbs
        :items="[
            {text: $tc('electricity-index.electricity-index', 2), to: {name: 'electricity-index'}, exact: true},
            {text: electricityIndex?.name, to: {name: 'electricity-tariff'}, exact: true},
            {text: $tc( isEdit ? 'electricity-tariff.edit' : 'electricity-tariff.add', 2)},
        ]"
        divider=">"
    ></v-breadcrumbs>


    <div class="mt-5">
      <headline>{{ $tc('electricity-tariff.electricity-tariff') }}</headline>
      <v-row>
        <v-col cols="12">
          <v-form ref="form" @submit.prevent="save">
            <v-row>
              <v-col cols="12" md="6">
                <form-field
                    type="date"
                    :label="$t('electricity-tariff.validity-start-date')"
                    v-model="form.validityStartDate"
                    :rules="[
                        commonRules.required,
                    ]"
                />
              </v-col>
              <v-col cols="12" md="6">
                <form-field
                    type="date"
                    :label="$t('electricity-tariff.validity-end-date')"
                    v-model="form.validityEndDate"
                    :rules="[
                        commonRules.required,
                    ]"
                    col-field="9"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <form-field
                    input-type="number"
                    :label="$t('electricity-tariff.value-per-kwh')"
                    v-model.number="form.valuePerKWh"
                    :rules="[
                        commonRules.required,
                    ]"
                    col-field="9"
                />
              </v-col>
            </v-row>

            <v-row class="mt-6">
              <v-col cols="12" class="text-center">
                <v-btn type="submit" color="primary">
                  {{ $t('save') }}
                </v-btn>
              </v-col>
            </v-row>

          </v-form>

          <v-divider class="my-10"></v-divider>

          <v-row>
            <v-col class="text-center">
              <v-btn small @click="deleteItem">
                {{ $t('delete') }}
              </v-btn>
            </v-col>
          </v-row>

        </v-col>
      </v-row>

    </div>

  </div>
</template>

<script>


import CustomerRepository from "@repository/CustomerRepository";
import RulesMixin from "@mixins/RulesMixin";
import ElectricityTariffRepository from "@repository/ElectricityTariffRepository";
import ElectricityIndexRepository from "@repository/ElectricityIndexRepository";

export default {
  components: {

  },
  data() {
    return {
      electricityIndex: null,
      form: {
        name: null
      },
    }
  },

  mixins: [
    RulesMixin,
  ],


  mounted() {
    if(!this.currentUser.permissions.includes('OPERATOR_WRITE')) {
      this.$router.replace({name: 'dashboard'})
      return
    }
    this.loadElectricityIndex()
    if(this.isEdit) {
      this.loadData()
    }

  },

  watch: {
    form: {
      handler() {
        this.setUnsavedChanges()
      },
      deep: true
    }
  },

  computed: {
    id() {
      return this.$route.params.id ?? null
    },
    electricityIndexId() {
      return this.$route.params.electricityIndexId ?? null
    },

    isEdit() {
      return !!this.id
    }
  },

  methods: {

    loadElectricityIndex() {
      ElectricityIndexRepository.get(this.electricityIndexId).then(result => {
        this.electricityIndex = result
      }).catch(err => {
        this.notifyError(err)
      })
    },


    cancel() {

    },


    loadData() {
      ElectricityTariffRepository.get(this.id).then(result => {
        this.form = result
        this.$nextTick(() => {
          this.cleanUnsavedChanges()
        })
      }).catch(err => {
        this.notifyError(err)
      })
    },

    save() {

      if(this.$refs.form.validate()) {
        this.showLoading(true)

        if(this.isEdit) {
          ElectricityTariffRepository.update(this.id, this.form).then(response => {
            this.showLoading(false)
            this.cleanUnsavedChanges()
            this.$dialog.notify.success(this.$t('update-success'))
            this.$router.push({name: 'electricity-tariff'})
          }).catch(err => {
            this.notifyError(err)
          })
        } else {
          ElectricityTariffRepository.create(this.electricityIndexId, this.form).then(response => {
            this.showLoading(false)
            this.cleanUnsavedChanges()
            this.$dialog.notify.success(this.$t('created-successfully'))
            this.$router.push({name: 'electricity-tariff'})
          }).catch(err => {
            this.notifyError(err)
          })
        }

      }

    },


    deleteItem() {
      this.$dialog.confirm({text: this.$t('are-you-sure')}).then(result => {
        if (result) {
          this.showLoading(true)
          ElectricityTariffRepository.delete(this.id).then(result => {
            this.showLoading(false)
            this.$dialog.notify.success(this.$t('delete-success'))
            this.$router.replace({name: 'electricity-tariff'})
          }).catch(err => {
            this.notifyError(err)
            this.showLoading(false)
          })
        }
      })
    }
  }
}
</script>

<style lang="scss">
.electricity-tariff {

}
</style>
